/******
 *
 * {
    agentId: null
    lastIocSeenTime: 1562029847452
    numberOfDetections: 6
    numberOfHosts: 1
    numberOfLateralMovements: 0
    riskMomentum: 0
    riskScore: 0
    startTime: 1562029810208
    state: "ACTIVE"
    trailIdHash: "alpha.agent-9:92860292"
    trailRiskHistInfoList: []
  }
 *
 *
 */
import { DATETIME_FORMAT } from '@/constants/datetime.constants'

const privilegedTrailsMetaInfo = {
  meta: {
    columns: [
      {
        datatype: 'string',
        description: 'Trail Identifier',
        label: 'Trail ID',
        sortable: true,
        name: 'trailIdLabel',
        display: 'link',
        pathTo: 'attack-track-details',
        params: {
          name: 'trailId',
          keyLookup: 'trailIdHash'
        },
        'min-width': 125
      },
      {
        datatype: 'number',
        description: 'Number of Activities',
        label: 'Activities',
        sortable: true,
        name: 'numberOfDetections',
        display: 'link',
        pathTo: 'trail-iocs',
        query: [
          {
            name: 'trailId',
            keyLookup: 'trailIdHash'
          },
          { name: 'trailLabel', keyLookup: 'trailIdLabel' },
          { name: 'trailState', keyLookup: 'state' }
        ],
        'min-width': 120
      },
      {
        datatype: 'number',
        description: 'Number of Hosts Involved',
        label: 'Hosts Involved',
        sortable: true,
        name: 'numberOfHosts',
        'min-width': 150
      },
      {
        datatype: 'number',
        description: 'Lateral Movements',
        label: 'Lateral Movements',
        name: 'numberOfLateralMovements',
        sortable: true,
        'min-width': 175
      },
      {
        datatype: 'dwelltime_string',
        format: DATETIME_FORMAT,
        description: 'Detection Time',
        label: 'Dwell Time',
        name: 'dwellTime',
        sortable: true,
        'min-width': 150
      },
      {
        datatype: 'objectpath',
        description: 'Cyber Kill Chain',
        label: 'Cyber Kill Chain',
        sortable: false,
        name: 'killChainData',
        display: 'component',
        component: 'CyberKillChainTickChart',
        componentKey: 'id',
        'min-width': 150
      },
      {
        datatype: 'datetime',
        format: DATETIME_FORMAT,
        description: 'Last Detection',
        label: 'Latest Detection',
        name: 'lastIocSeenTime',
        sortable: true,
        'min-width': 200
      },
      {
        datatype: 'string',
        description: 'Trail State',
        display: 'stateTag',
        label: 'State',
        name: 'state',
        displayKey: [
          {
            key: 'ACTIVE',
            display: 'Active',
            color: '#b0e9d1',
            textColor: '#00602e'
          },
          { key: 'INACTIVE', display: 'Inactive', color: '#f8f8f8' },
          { key: 'MITIGATED', display: 'Mitigated', color: '#f8f8f8' },
          { key: 'REOPENED', display: 'Reopened', color: '#f8f8f8' }
        ],
        'min-width': 100
      }
    ]
  }
}

export { privilegedTrailsMetaInfo }



// WEBPACK FOOTER //
// ./src/column-header/trail/privileged-trails-meta.js